module.exports = __webpack_public_path__ + "static/media/dashboard-statement.49fe2879.png";